export default __webpack_public_path__ + "static/media/pin-new.5540f50a.svg";